import type { DesktopClientPlatform } from "@/src/features/downloads/clientPlatform";
import type { DesktopDownloadPlatform } from "@/src/features/downloads/desktopDownloads";

// Lives outside LandingDesktopNavigation so the homepage can order download
// items without eagerly loading the navigation component.
export function orderLandingDesktopDownloadItems<TItem extends { key: DesktopDownloadPlatform }>(
  items: readonly TItem[],
  detectedOS: DesktopClientPlatform,
): TItem[] {
  if (detectedOS === "unknown") return [...items];

  return [
    ...items.filter((item) => item.key === detectedOS),
    ...items.filter((item) => item.key !== detectedOS),
  ];
}
